exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container[data-v-3e0c9f14] {\n  padding: 10px;\n  padding-bottom: 30px;\n}\n.list[data-v-3e0c9f14] {\n  margin: 0 20px;\n}\n.item[data-v-3e0c9f14] {\n  margin: 10px 0;\n}\n.clearfix[data-v-3e0c9f14]:before,\n.clearfix[data-v-3e0c9f14]:after {\n  display: table;\n  content: \"\";\n}\n.clearfix[data-v-3e0c9f14]:after {\n  clear: both\n}\n", ""]);

// exports
